'use strict';

exports.updateEarlyAccessAttributes = (earlyAccessObj) => {
    var $earlyAccessIcon = $('.b-product-quickview-images .b-EarlyAccess-Icon, .l-pdp-images .b-EarlyAccess-Icon');
    if ('earlyAccessBadge' in earlyAccessObj && $('.b-EarlyAccess-Icon').length) {
        $earlyAccessIcon.find('.ea-Icon-Text').html(earlyAccessObj.earlyAccessBadge);
        $earlyAccessIcon.removeClass('d-none');
    } else {
        $earlyAccessIcon.addClass('d-none');
    }
};
